<template>
  <article class="icon-teaser">
    <header class="icon-teaser__header">
      <a
        class="icon-teaser__media"
        :href="url"
        :title="typeInfo.name"
      >
        <span class="badge">
          <img
            alt=""
            width="72"
            height="72"
            :src="typeInfo.image"
          >
          <span
            v-if="isNew"
            class="badge__text"
          >Neu</span>
        </span>
      </a>

      <h3 class="icon-teaser__title">
        <!-- eslint-disable vue/no-v-html -->
        <a
          class="icon-teaser__link"
          :href="url"
          v-html="titleWithBreaks"
        />
        <!-- eslint-enable vue/no-v-html -->
      </h3>
    </header>

    <p class="icon-teaser__description">
      <span>{{ description | truncate }}</span>
      <a
        class="icon-teaser__more"
        :href="url"
      >
        Weiterlesen
      </a>
    </p>
  </article>
</template>

<script>
import getTypeInfo from '../functions/get-type-info'

export default {
  name: 'CIconTeaser',

  filters: {
    truncate (text) {
      if (text.length <= 200) {
        return text
      }

      return text.substring(0, 200) + '…'
    }
  },

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    isNew: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    }
  },

  computed: {
    typeInfo () {
      return getTypeInfo[this.type]
    },
    titleWithBreaks () {
      return this.title.replace(/(?:\r\n|\r|\n)/g, '<br />')
    }
  }
}
</script>
